import { useRef } from 'react';
import AdminSidebar from './AdminSidebar';

const AdminLayout = () => {
  const sidebarRef = useRef(null);
  return (
    <>
      {/* <div className='header header-one'>
        <AdminHeader onClick={toggleSidebar} />
      </div> */}
      <div className='sidebar' ref={sidebarRef} >
        <AdminSidebar />
      </div>

      {/* <footer className="text-center text-lg-start" style={{ bottom: 0,position: 'absolute', width: '90%' }}>
      <div className="text-center p-2">
        Powered by Alsaffron System.
      </div>
      </footer> */}
    </>
  );
};
export default AdminLayout;
